import { type ReactElement } from 'react';
import styles from './style.module.scss';

interface TermsOfUseContentProperties {
  readonly className?: string;
}

const termsOfUseSections = [
  {
    heading: 'Internal Scania Information',
    body: 'Battery Monitoring contains proprietary Scania Battery Intelligence, including predictive models, battery health assessments, and analytical insights. This information is confidential and must not be shared externally unless the customer explicitly requests access to their own vehicle data and disclosure complies with Scania policy.',
  },
  {
    heading: 'State of Health (SoH)',
    body: 'For BEV1 vehicles, State of Health (SoH) is estimated using an approximate calculation model. For BEV3 vehicles, SoH is derived from vehicle telemetry but may still differ slightly from the onboard vehicle reading due to differences in calculation methods and data processing.',
  },
  {
    heading: 'Data Accuracy',
    body: 'Battery Monitoring provides the best available representation of vehicle data. Minor differences compared to the vehicle or other Scania systems are expected due to calculation methods, synchronization, and standardized values (e.g. 623 kWh displayed as 624 kWh).',
  },
] as const;

const TermsOfUseContent = ({ className }: TermsOfUseContentProperties): ReactElement => (
  <div className={className ? `${styles.content} ${className}` : styles.content}>
    <p className={styles.eyebrow}>Service usage guidelines</p>
    <h1 className={styles.title}>Terms of use</h1>
    <p className={styles.intro}>When using Battery Monitoring I accept the following conditions:</p>
    <div className={styles.sections}>
      {termsOfUseSections.map((section) => (
        <section key={section.heading}>
          <h2 className={styles['section-heading']}>{section.heading}</h2>
          <p className={styles['section-body']}>{section.body}</p>
        </section>
      ))}
    </div>
  </div>
);

export default TermsOfUseContent;
